import { AuthMethods } from "@/lib/consts/auth";
import facebookService from "@/lib/services/facebook";
import googleService from "@/lib/services/google";

export const getProfileImageUrl = async (authMethod: AuthMethods, userToken: string) => {
    switch (authMethod) {
        case AuthMethods.FACEBOOK:
            return await facebookService.getProfileImageUrl(userToken);
        case AuthMethods.GOOGLE:
            return await googleService.getProfileImageUrl(userToken);
        default:
            return null;
    }
}